document.addEventListener('DOMContentLoaded', function() {

  var product = window.pjProduct;
  if (!product) return;

  var variants = product.variants;
  var options = product.options; // ['Metal','Peso Total','Origen'] o ['Metal','Origen']

  // Estado actual: array de valores seleccionados por posición (0-indexed)
  var selected = variants[0]
    ? [variants[0].option1, variants[0].option2, variants[0].option3].filter(Boolean)
    : [];

  // ── Colores de metal ──
  var metalColors = {
    'blanco': '#C8D4DC',
    'amarillo': '#D4A820',
    'platino': '#E2E2E2',
    'rosado': '#E8B4B8'
  };

  // Aplicar color a swatches
  document.querySelectorAll('[data-metal-color]').forEach(function(sw) {
    var slug = sw.dataset.metalColor.toLowerCase();
    for (var key in metalColors) {
      if (slug.indexOf(key) !== -1) {
        sw.style.background = metalColors[key];
        break;
      }
    }
  });

  // ── Encontrar variante por opciones seleccionadas ──
  function findVariant(sel) {
    return variants.find(function(v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.every(function(o, i) { return sel[i] === o; });
    }) || null;
  }

  // ── Actualizar imagen principal al cambiar variante ──
  function updateVariantImage(variant) {
    if (!variant) return;
    var imgMap = window.pjVariantImages || {};
    var newSrc = imgMap[String(variant.id)];
    if (!newSrc) return;

    var mainImg = document.getElementById('pj-main-img');
    if (mainImg) mainImg.src = newSrc;

    // Resetear counter al slide 1
    var counter = document.getElementById('pj-img-current');
    if (counter) counter.textContent = '1';

    // Activar el primer thumb
    document.querySelectorAll('.pj-thumb').forEach(function(t) {
      t.classList.remove('pj-thumb--active');
    });
    var firstThumb = document.querySelector('.pj-thumb');
    if (firstThumb) firstThumb.classList.add('pj-thumb--active');
  }

  // ── Actualizar precio y variant ID ──
  function updatePrice(variant) {
    var priceEl = document.getElementById('pj-price');
    var originEl = document.getElementById('pj-price-origin');
    var variantInput = document.getElementById('pj-variant-id');
    var ctaBtn = document.getElementById('pj-add-to-cart');

    if (variant && variant.available) {
      var price = (variant.price / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      });
      priceEl.textContent = '$' + price;

      // Determinar origen para el subtítulo
      var originVal = variant.option3 || variant.option2 || '';
      if (originEl) {
        originEl.textContent = originVal.indexOf('Lab') !== -1 ? 'Lab-Grown' :
                               originVal.indexOf('Natural') !== -1 ? 'Natural' : '';
      }

      if (variantInput) variantInput.value = variant.id;
      if (ctaBtn) {
        ctaBtn.disabled = false;
        ctaBtn.textContent = '✦  Agregar al carrito';
      }
    } else {
      priceEl.textContent = 'No disponible';
      if (ctaBtn) {
        ctaBtn.disabled = true;
        ctaBtn.textContent = 'No disponible';
      }
    }
  }

  // ── Actualizar labels de selected value ──
  function updateLabels() {
    // Metal
    var metalVal = document.getElementById('pj-metal-val');
    if (metalVal) metalVal.textContent = selected[0] || '';

    // Dimensión (si existe, es índice 1 cuando hay 3 opciones)
    if (options.length === 3) {
      var dimVal = document.getElementById('pj-dim-val-2');
      if (dimVal) dimVal.textContent = selected[1] || '';
    }
  }

  // ── Deshabilitar botones de dimensión que no tienen variante disponible ──
  function updateDimAvailability() {
    if (options.length < 3) return;
    var dimContainer = document.querySelector('.pj-dims');
    if (!dimContainer) return;

    dimContainer.querySelectorAll('.pj-dbtn').forEach(function(btn) {
      var testSelected = [selected[0], btn.dataset.value, selected[2]];
      var variant = findVariant(testSelected);
      if (!variant || !variant.available) {
        btn.classList.add('pj-dbtn--na');
      } else {
        btn.classList.remove('pj-dbtn--na');
      }
    });
  }

  // ── Handler genérico para todos los selectores ──
  function handleSelection(optionIndex, value) {
    // optionIndex es 1-based desde el liquid (data-option-index)
    var idx = optionIndex - 1;
    selected[idx] = value;

    // Actualizar UI activos
    document.querySelectorAll('[data-option-index="' + optionIndex + '"]').forEach(function(btn) {
      btn.classList.remove('pj-mbtn--active', 'pj-dbtn--active', 'pj-obtn--active');
      if (btn.dataset.value === value) {
        if (btn.classList.contains('pj-mbtn')) btn.classList.add('pj-mbtn--active');
        else if (btn.classList.contains('pj-dbtn')) btn.classList.add('pj-dbtn--active');
        else if (btn.classList.contains('pj-obtn')) btn.classList.add('pj-obtn--active');
      }
    });

    updateLabels();
    updateDimAvailability();
    var variant = findVariant(selected);
    updatePrice(variant);
    updateVariantImage(variant);
  }

  // ── Event delegation — un solo listener ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-option-index][data-value]');
    if (!btn) return;
    if (btn.classList.contains('pj-dbtn--na')) return;
    var idx = parseInt(btn.dataset.optionIndex, 10);
    handleSelection(idx, btn.dataset.value);
  });

  // ── Thumbnails ──
  var mainImg = document.getElementById('pj-main-img');
  var imgCurrent = document.getElementById('pj-img-current');

  document.querySelectorAll('.pj-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.pj-thumb').forEach(function(t) {
        t.classList.remove('pj-thumb--active');
      });
      thumb.classList.add('pj-thumb--active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
      if (imgCurrent) imgCurrent.textContent = thumb.dataset.index;
    });
  });

  // ── Add to cart con AJAX (sin reload) ──
  var form = document.getElementById('pj-form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = document.getElementById('pj-variant-id').value;
      if (!variantId) return;

      var ctaBtn = document.getElementById('pj-add-to-cart');
      var origText = ctaBtn.textContent;
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Agregando...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        ctaBtn.textContent = '✓  Agregado al carrito';
        // Actualizar contador del carrito si existe
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var bubble = document.getElementById('cart-count-bubble');
            if (bubble) bubble.textContent = cart.item_count;
            var cartIcon = document.querySelector('.dm-header__cart-count, [data-cart-count]');
            if (cartIcon) cartIcon.textContent = cart.item_count;
          });
        setTimeout(function() {
          window.location.href = '/cart';
        }, 600);
      })
      .catch(function() {
        ctaBtn.disabled = false;
        ctaBtn.textContent = origText;
      });
    });
  }

  // ── Init ──
  updateDimAvailability();
  updateLabels();

});
